<template>
  <v-dialog
    hide-overlay
    fullscreen
    v-model="dialog"
    @keydown.esc="onDialogClose"
    persistent
    scrollable
  >
    <v-card color="white" flat class="platform-font dialog-container">
      <quotation-overview :quotation="quotation"></quotation-overview>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "../../const";

export default {
  props: ["quotation", "dialog"],

  data() {
    return {};
  },

  watch: {
    // dialog: function() {
    //     if(this.dialog){
    //     }
    // },
  },

  methods: {
    onDialogClose() {
      this.$emit("dialog-close", constant.DIALOG_QUOTATION_OVERVIEW, null, false);
    },
  },
};
</script>

<style></style>
